import httpClient from '@/apis/base/httpclient';
import BaseAPI from '@/apis/base/baseApi';
class AVAApi extends BaseAPI {
  constructor() {
    super();
  }
  apiName = 'TaskGo';
  controllerName = 'MISAAVA';

  async getConnectAVA() {
    let request = {
      url: this.getAPIUrl() + '/connection'
    };
    return await httpClient.getAsync(request, true);
  }
}

export default new AVAApi();
